'use strict'

module.exports = {
  custom: {
  },
  messages: {
  }
}
